import { InstallmentStatusActions } from "../actions";

const initialState = {
  generalInformation: null,
  files: {
    rows: [],
    rowCount: 0,
    pageCount: 0,
  },
  fileControls: [],
};

export default function installmentStatus(state = initialState, action) {
  switch (action.type) {
    case InstallmentStatusActions.ACTION_SAVE_INSTALLMENT_STATUS_GENERAL_INFORMATION:
      return {
        ...state,
        generalInformation: action.payload,
      };
    case InstallmentStatusActions.ACTION_SAVE_INSTALLMENT_STATUS_FILES:
      return {
        ...state,
        files: action.payload,
      };
    case InstallmentStatusActions.ACTION_SAVE_INSTALLMENT_STATUS_FILE_CONTROLS:
      return {
        ...state,
        fileControls: action.payload,
      };
    default:
      return state;
  }
}

export function getInstallmentStatusGeneralInformation(state) {
  return state.installmentStatus.generalInformation;
}

export function getInstallmentStatusFiles(state) {
  return state.installmentStatus.files;
}

export function getInstallmentStatusFileControls(state) {
  return state.installmentStatus.fileControls;
}
